import React from 'react';
import {connect} from 'react-redux';
import {Field} from "redux-form";
import {injectIntl} from "react-intl";

import ExpandSection from "../../Generic/expandSection";
import {toggleSectionOpened} from "../AccountActions";
import {ACCOUNT_SECTIONS} from "./sectionNames";
import {FormField, required} from "../FormField";

class ShipFromAddress extends React.Component {

  render() {

    const {intl} = this.props;
    const {isCustomer, canEditFields} = this.props.accountPageInfo;

    return (
      <ExpandSection opened={this.props.sectionsOpened.includes(ACCOUNT_SECTIONS.ship_from_address)}
                     onClick={() => this.props.toggleSectionOpened(ACCOUNT_SECTIONS.ship_from_address)}
                     title={intl.formatMessage({id: "account.shipFromAddress.sectionTitle"})}>
        <div className="acc-container">
          <div className="acc-container__row">
            <div className="acc-block">
              <Field name="shipFromAddress.name"
                     component={FormField}
                     label={`${intl.formatMessage({id: "account.businessAddress.businessName"})} ${isCustomer ? '' : '*'}`}
                     validate={(v) => (!isCustomer ? required(v) : undefined)}
                     disabled={!canEditFields}/>
              <div className="acc-three">
                <div className="acc-three__item">
                  <Field name="shipFromAddress.city"
                         component={FormField}
                         label={`${intl.formatMessage({id: "account.businessAddress.city"})} ${isCustomer ? '' : '*'}`}
                         validate={(v) => (!isCustomer ? required(v) : undefined)}
                         disabled={!canEditFields}/>
                </div>
                <div className="acc-three__item">
                  <Field name="shipFromAddress.state"
                         component={FormField}
                         label={`${intl.formatMessage({id: "account.businessAddress.state"})} ${isCustomer ? '' : '*'}`}
                         validate={(v) => (!isCustomer ? required(v) : undefined)}
                         disabled={!canEditFields}/>
                </div>
                <div className="acc-three__item">
                  <Field name="shipFromAddress.zip"
                         component={FormField}
                         label={`${intl.formatMessage({id: "account.businessAddress.zipCode"})} ${isCustomer ? '' : '*'}`}
                         validate={(v) => (!isCustomer ? required(v) : undefined)}
                         disabled={!canEditFields}/>
                </div>
              </div>
            </div>
            <div className="acc-block">
              <Field name="shipFromAddress.address1"
                     component={FormField}
                     label={`${intl.formatMessage({id: "account.businessAddress.businessAddress1"})} ${isCustomer ? '' : '*'}`}
                     validate={(v) => (!isCustomer ? required(v) : undefined)}
                     disabled={!canEditFields}/>
              <Field name="shipFromAddress.address2"
                     component={FormField}
                     label={intl.formatMessage({id: "account.businessAddress.businessAddress2"})}
                     disabled={!canEditFields}/>
            </div>
          </div>
        </div>
      </ExpandSection>
    )
  }

}

const mapStateToProps = (store) => {
  const {sectionsOpened, accountPageInfo} = store.accountState;
  return {
    sectionsOpened,
    accountPageInfo,
    formValues: (store.form && store.form.newEntity && store.form.newEntity.values) || {}
  };
};

const mapDispatchToProps = {
  toggleSectionOpened
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ShipFromAddress)
)

